/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Supportedplatforms2Inputs */

const id_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform yang Didukung`)
};

const ms_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Disokong`)
};

const da_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understøttede Platforme`)
};

const de_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützte Plattformen`)
};

const en_us2_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported Platforms`)
};

const es_es2_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas compatibles`)
};

const es_mx2_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas compatibles`)
};

const fil_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Suportadong Platform`)
};

const fr_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plateformes prises en charge`)
};

const it_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piattaforme supportate`)
};

const hu_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Támogatott platformok`)
};

const nl_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteunde platforms`)
};

const no_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støttede plattformer`)
};

const pl_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsługiwane platformy`)
};

const pt_br2_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas suportadas`)
};

const pt_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas suportadas`)
};

const ro_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme suportate`)
};

const fi_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuetut alustat`)
};

const sv_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stödda plattformar`)
};

const vi_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nền tảng hỗ trợ`)
};

const tr_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desteklenen Platformlar`)
};

const cs_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podporované platformy`)
};

const bg_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддържани платформи`)
};

const ru_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживаемые платформы`)
};

const uk_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримувані платформи`)
};

const ar_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنصات المدعومة`)
};

const hi_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समर्थित प्लेटफ़ॉर्म`)
};

const th_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพลตฟอร์มที่รองรับ`)
};

const ja_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対応プラットフォーム`)
};

const zh_cn2_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持平台`)
};

const zh_hant1_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支援平台`)
};

const ko_offerdetail_table_supportedplatforms2 = /** @type {(inputs: Offerdetail_Table_Supportedplatforms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지원 플랫폼`)
};

/**
* | output |
* | --- |
* | "Supported Platforms" |
*
* @param {Offerdetail_Table_Supportedplatforms2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_supportedplatforms2 = /** @type {((inputs?: Offerdetail_Table_Supportedplatforms2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Supportedplatforms2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "ms") return ms_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "da") return da_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "de") return de_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "fil") return fil_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "fr") return fr_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "it") return it_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "hu") return hu_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "nl") return nl_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "no") return no_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "pl") return pl_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "pt") return pt_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "ro") return ro_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "fi") return fi_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "sv") return sv_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "vi") return vi_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "tr") return tr_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "cs") return cs_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "bg") return bg_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "ru") return ru_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "uk") return uk_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "ar") return ar_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "hi") return hi_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "th") return th_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "ja") return ja_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_supportedplatforms2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_supportedplatforms2(inputs)
	return ko_offerdetail_table_supportedplatforms2(inputs)
});
export { offerdetail_table_supportedplatforms2 as "offerDetail.table.supportedPlatforms" }